module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Am5v4g/tc-custom/9780795350979.jpg?1737157722041",
      "alt": "This image is the cover for the book Japanese Baseball"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Japanese Baseball\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Short stories filled with empathy, laughter, and a love of the game, from the award-winning author of "), _c('i', [_vm._v("Shoeless Joe")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" W.P. Kinsella weaves his characters into the thrill of the game, be it in Japan, Central America, Canada, or the United States, with a variety of comic, tragic, and mystical results. This collection captures the dazzling wit, compelling insight, and obsession with baseball that have made Kinsella more popular than a ballpark frank."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “There is a new depth and gentleness to Kinsella’s storytelling here, a more subtle nuance than his readers may be accustomed to. In ‘The Kowloon Club,’ the baseball club is persuaded to hire a Feng Shui master to determine the site for their new park…‘The First and Last Annual Six Towns Old-Timers’ Game’ is vintage Kinsella…The final extra-base hit is a deeply felt, introspective look at the half-lived life of an umpire and the reasons he continues to be a part of the game, even when his marriage is going foul.”—"), _c('i', [_vm._v("Quill & Quire")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      W. P. Kinsella\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0